// Copyright (c) 2020 WiseTime. All rights reserved.

import React, { useEffect } from "react"
import styled, { keyframes } from "styled-components/macro"
import ActionTimeRowList from "./ActionTimeRowList"
import ActionPaneTimeRowsHeader from "./ActionPaneTimeRowsHeader"
import { Paper } from "features/shared/styles"
import { TimeRow } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"
import { hasTrashedItems } from "../timeRows"
import ActionPaneButtonsTrash from "./ActionPaneButtonsTrash"
import TimeRowsActionPaneButtons from "./TimeRowsActionPaneButtons"

const slide = keyframes`
  0% {
    transform: translate3d(0, 100%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
`

const Wrapper = styled.div`
  ${Paper};

  @media (max-width: ${({ theme }): string => theme.screen.sm}) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: ${({ theme }) => theme.actionPaneShadow};
    will-change: auto;
    animation-name: ${slide};
    animation-duration: 200ms;
    animation-timing-function: ease;
    animation-fill-mode: both;
    border-top: 1px solid ${({ theme }) => theme.colors.gainsboro};
  }
`

type Props = {
  timeRows: TimeRow.AsObject[],
  hasTagWithDifferentAssignee: boolean,
}

const ActionPaneTimeRows = ({
  timeRows,
  hasTagWithDifferentAssignee,
}: Props): React.ReactElement<Props> | null => {
  const isTrashView = hasTrashedItems(timeRows)

  useEffect(() => {
    const cookieBannerButton = document.querySelector(".cc-revoke") as HTMLElement | null
    if (!cookieBannerButton) {
      return
    }
    cookieBannerButton.style.display = "none"
    return () => {
      cookieBannerButton?.removeAttribute("style")
    }
  }, [])

  return (
    <Wrapper>
      {timeRows.length > 0 && <ActionPaneTimeRowsHeader timeRows={timeRows} isTrashView={isTrashView}/>}
      {isTrashView && <ActionTimeRowList timeRows={timeRows}/>}
      {
        isTrashView ? <ActionPaneButtonsTrash timeRows={timeRows}/>
          : <TimeRowsActionPaneButtons timeRows={timeRows} hasTagWithDifferentAssignee={hasTagWithDifferentAssignee}/>
      }
    </Wrapper>
  )
}

export default ActionPaneTimeRows
